import React from 'react';
import PropTypes from 'prop-types';

export default function FilterButton({
  label,
  isActive,
  isStart,
  isEnd,
  onClick,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`py-3 px-4 text-sm font-medium outline-none whitespace-nowrap hover:bg-cyan-600 dark:hover:bg-cyan-600 focus-visible:bg-cyan-600 dark:focus-visible:bg-cyan-600 hover:text-white focus:text-white border-y border-cyan-500 dark:border-cyan-700 ${
        isActive ? 'bg-cyan-500 dark:bg-cyan-700 text-white' : ''
      } ${isStart ? 'rounded-l-md border-l' : ''} ${
        isEnd ? 'rounded-r-md border-r' : ''
      } ${!isStart && !isEnd ? 'border-x' : ''}`}>
      {label}
    </button>
  );
}

FilterButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  isStart: PropTypes.bool,
  isEnd: PropTypes.bool,
};

FilterButton.defaultProps = {
  isActive: false,
  isStart: false,
  isEnd: false,
};
